/**
 * Converts a plural to singular.
 * @param {string} plural - eg. 'super-admins'
 * @return {string} - eg. 'super-admin'
 */
export const toSingular = ( plural ) => {
	return plural.replace( /s$/, '' );
};

/**
 * Converts a singular to plural.
 * @param {string} singular - eg. 'super-admin'
 * @return {string} - eg. 'super-admins'
 */
export const toPlural = ( singular ) => {
	return `${singular}s`;
};
